export default "__VITE_ASSET__DL$QBFMn__"